import { getCategoryItems, refreshCategoryItems, loadContentPrivateBlog } from '../thunk';

import type { TableBaseColumnType, TableBaseRowType } from '@/components/TableBase/Body';
import type { PrivateBlogCategoryJson } from '@/types/domain/privateBlog/entities/privateBlogCategoryEntity';
import type { PrivateBlogJson } from '@/types/domain/privateBlog/entities/privateBlogEntity';
import type { CategoryItemsType } from '@/types/domain/privateBlog/redux';
import type { Dispatch } from 'redux';

import { LastModifiedDatetime } from '@/domain/privateBlog/service/entity/valueObjects/lastModifiedDatetime';

/**
 * 履歴コントローラー
 */
export class HistoryController {
  private dispatch: Dispatch<any>;

  private category: PrivateBlogCategoryJson;

  private pageList: PrivateBlogJson[] = [];

  private nurseryId: string;

  private isEnableLoading: boolean;

  constructor(
    dispatch: Dispatch<any>,
    category: PrivateBlogCategoryJson,
    categoryItems: CategoryItemsType | undefined,
    nurseryId: string,
  ) {
    this.dispatch = dispatch;
    this.category = category;
    const categoryItem = categoryItems && categoryItems[this.category.categoryId];
    this.pageList = (categoryItem && categoryItem.items) || [];
    this.nurseryId = nurseryId;
    this.isEnableLoading = Boolean(categoryItem && categoryItem.nextToken);
  }

  /**
   * Row
   */
  get rows() {
    const items = this.pageList;
    const rows: { [key: string]: string }[] = [];
    for (let i = 0; i < items.length; i += 1) {
      // const cdate = CreateDatetime.create(new Date(items[i].createDatetime));
      const mdate = LastModifiedDatetime.create(new Date(items[i].publishDatetime));
      rows.push({
        // cdate: cdate.toStringDateDisplay(),
        mdate: mdate.toStringDateDisplay(),
        publishDatetime: items[i].publishDatetime,
        title: items[i].title,
      });
    }
    return rows;
  }

  /**
   * Columns
   */
  get columns() {
    const columns: TableBaseColumnType[] = [
      { id: 'title', label: 'タイトル' },
      // { id: 'cdate', label: CreateDatetime.label },
      { id: 'mdate', label: LastModifiedDatetime.label },
    ];
    return columns;
  }

  /**
   * 追加読込可否を取得
   * @returns 追加読込可否
   */
  getIsEnableLoading = () => this.isEnableLoading;

  /**
   * 追加読込アクションを取得
   * @returns アクション
   */
  getActionGetItem = () => () => this.dispatch(getCategoryItems({
    nurseryId: this.nurseryId,
    categoryId: this.category.categoryId,
  }));

  /**
   * 再読込アクションを取得
   * @returns アクション
   */
  getActionRefreshItem = () => () => this.dispatch(
    refreshCategoryItems({ nurseryId: this.nurseryId }),
  );

  /**
   * 閲覧アクションを取得
   * @returns アクション
   */
  getActionView = (
    setDetailPrivateBlogJson:
      (value: PrivateBlogJson | undefined) => void,
  ) => (r: TableBaseRowType) => {
    const data = this.pageList.find((v) => v.publishDatetime === r.publishDatetime);
    if (data) {
      this.dispatch(loadContentPrivateBlog({ data, nurseryId: this.nurseryId }));
      setDetailPrivateBlogJson(data);
    }
  };

  /**
   * 詳細アクションを取得
   * @param setDetailPrivateBlogJson setDetailPrivateBlogJson
   * @returns アクション
   */
  getActionDetail(
    setDetailPrivateBlogJson:
      (value: PrivateBlogJson | undefined) => void,
  ) {
    return (data: PrivateBlogJson | undefined) => {
      if (data) {
        this.dispatch(loadContentPrivateBlog({ data, nurseryId: this.nurseryId }));
        setDetailPrivateBlogJson(data);
      } else {
        this.dispatch(loadContentPrivateBlog({ data: undefined, nurseryId: this.nurseryId }));
        setDetailPrivateBlogJson(undefined);
      }
    };
  }
}
